import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { CreditCheckResponseService } from '../../../../common/store/state/order/orderv2/order-api-response/cc-response.service';
import { VoicePackageSelectionStateService } from '../../../../common/store/state/order/orderv2/workflows/voice/voice-package-selection/voice-package-selection-state.service';
import { OrderBaseComponent } from '../../order-base.component';
import { WirelessSigfanStateService } from '../../../../common/store/state/order/orderv2/workflows/wireless/wireless-sigfan.state.service';

@Component({
  selector: 'app-order-menu-customer-credit-info',
  standalone: false,
  templateUrl: './order-menu-customer-credit-info.component.html',
  styleUrl: './order-menu-customer-credit-info.component.scss'
})
export class OrderMenuCustomerCreditInfoComponent extends OrderBaseComponent {
  @Input() showRefresh = true;
  @Output() refreshCreditInfo = new EventEmitter<void>();

  #creditCheckResponseService = inject(CreditCheckResponseService);
  #voicePackageSelectionStateService = inject(VoicePackageSelectionStateService);
  #wirelessSigfanStateService = inject(WirelessSigfanStateService);


  hasCreditInformation() {
    return !!(
      this.hasInternetCreditDecision()
      || this.hasVideoCreditDecision()
      || this.hasWirelessCreditDecision()
      || this.hasVoiceCreditDecision()
    );
  }

  hasInternetCreditDecision = computed(() => {
    return this.#creditCheckResponseService.hasInternetCreditDecision();
  });
  hasVideoCreditDecision = computed(() => {
    return this.#creditCheckResponseService.hasVideoCreditDecision();
  });
  hasWirelessCreditDecision = computed(() => {
    return this.#creditCheckResponseService.hasWirelessCreditDecision();
  });
  hasVoiceCreditDecision = computed(() => {
    return this.#creditCheckResponseService.hasVoiceCreditDecision() && this.#voicePackageSelectionStateService.isPlanSelected();
  });

  internetCreditDetails = computed(() => {
    const internetAttCreditDecision = this.#creditCheckResponseService.internetAttCreditDecision();
    const internetRc1CreditDecision = this.#creditCheckResponseService.internetRc1CreditDecision();
    const orderNumber = internetAttCreditDecision?.OrderNumber || internetRc1CreditDecision?.CommonOrderID || null;
    const accountNumber = this.oqResponseService.internetOQComponent()?.BillingAccountNumber || null;
    const creditClass = internetAttCreditDecision?.CreditClass || internetRc1CreditDecision?.CreditClass || null;
    return { orderNumber, accountNumber, creditClass };
  });

  videoCreditDecision = computed(() => {
    const decision = this.#creditCheckResponseService.videoCreditDecision();
    const orderNumber = decision.CasApplicationNumber;
    const accountNumber = this.oqResponseService.videoOQComponent()?.BillingAccountNumber || null;
    const creditClass = decision.CreditClass;
    return { orderNumber, accountNumber, creditClass };
  });

  wirelessCreditDecision = computed(() => {
    const decision = this.#creditCheckResponseService.wirelessCreditDecision();
    const orderNumber = decision.CommonOrderID;
    const accountNumber = decision.BillingAccountNumber;
    const sigfan = this.#wirelessSigfanStateService.state();
    const linesApproved = this.capWirelessLinesToRequested(decision.NumberOfLinesEligible);
    let fanNumber = null;
    let sigfanDiscounType = null;
    if (sigfan) {
      fanNumber = sigfan.fanNumber;
      sigfanDiscounType = sigfan.fanGroup;
    }
    return { orderNumber, accountNumber, fanNumber, sigfanDiscounType, linesApproved, message: decision.DisplayMessageHtml };
  });

  voiceCreditDecision = computed(() => {
    return this.internetCreditDetails();
  });

  onRefreshCreditInfo() {
    this.refreshCreditInfo.emit();
  }
}
